/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlteracaoBeneficiarioAliases {
  ACTION_PRINT = 'action-print',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_FIELD_SITUACAO = 'autocomplete-field-situacao',
  AUTOCOMPLETE_SITUACAO_TRAB = 'autocomplete-situacao-trab',
  AUTOCOMPLETE_SUB_ESTIPULANTE = 'autocomplete-sub-estipulante',
  AVATAR_DADOS_BENEFICIARIO = 'avatar-dados-beneficiario',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_BENEFICIARY_CHANGE = 'fetch-beneficiary-change',
  FETCH_FIELD_SITUACAO = 'fetch-field-situacao',
  FETCH_SITUACAO_TRAB = 'fetch-situacao-trab',
  FETCH_SUB_ESTIPULANTE = 'fetch-sub-estipulante',
  FETCH_TIPO_DATA = 'fetch-tipo-data',
  FIELD_0 = 'field-0',
  FIELD_DADOS_BENEFICIARIO = 'field-dados-beneficiario',
  FIELD_DATA_CONTRATACAO = 'field-data-contratacao',
  FIELD_DATA_RESCISAO = 'field-data-rescisao',
  FIELD_SITUACAO = 'field-situacao',
  FIELD_SITUACAO_TRAB = 'field-situacao-trab',
  FIELD_SUB_ESTIPULANTE = 'field-sub-estipulante',
  FIELD_TIPO_DATA = 'field-tipo-data',
  FILTER_BENEFICIARY_CHANGE = 'filter-beneficiary-change',
  FILTERED_LIST = 'filtered-list',
  FIRST_AT_DATE_FIELD = 'first-at-date-field',
  FIRST_AT_FIELD = 'first-at-field',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_DYNAMIC_CONTENT_SITUACAO = 'hpms-dynamic-content-situacao',
  INPUT_0 = 'input-0',
  LAST_ACCESS_AT_DATE_FIELD = 'last-access-at-date-field',
  LAST_ACCESS_AT_FIELD = 'last-access-at-field',
  LAYOUT_1 = 'layout-1',
  LAYOUT_BENEFICIARY_CHANGE = 'layout-beneficiary-change',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_2 = 'mapper-2',
  MAPPER_3 = 'mapper-3',
  MAPPER_4 = 'mapper-4',
  MAPPER_DADOS_BENEFICIARIO = 'mapper-dados-beneficiario',
  MAPPER_FIELD_SITUACAO = 'mapper-field-situacao',
  MAPPER_SITUACAO_TRAB = 'mapper-situacao-trab',
  MAPPER_TIPO_DATA = 'mapper-tipo-data',
  TEXT_1 = 'text-1',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_DATA_CONTRATACAO = 'text-data-contratacao',
  TEXT_DATA_RESCISAO = 'text-data-rescisao',
  TEXT_FIELD_SITUACAO = 'text-field-situacao',
  TEXT_SITUACAO_TRAB = 'text-situacao-trab',
}
export { AlteracaoBeneficiarioAliases };
